export const calendarTranslations = {
    en: {
      titles: {
        head1: "All Events",
        head2: "Member News",
        head3: "Events in Photos",
      },
      
      about_us: "About Us"
    },
    fr: {
      about_us: "À propos de nous",
    
      titles:{head1:"Tous les évènements",head2:"Actualités des membres",head3:"Evènements en photos",},
  
    }
  };
